import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Kpa from "../axes/Kpa";

let LeafPressureRegressionMorning = {
    type: "line",
    label: "Leaf Pressure Regression Morning",
    fill: false,
    lineTension: 0,
    colorPalette: 6,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Kpa,
    xAxis:Time
};

export default LeafPressureRegressionMorning;



// WEBPACK FOOTER //
// ./src/components/chart/channels/LeafPressureRegressionMorning.js